import React from 'react';
import { CustomSVG } from '../../CustomSVG/CustomSVG';
import ReportingSvg from '../../../assets/icons/nav/reporting.svg?raw';

export const ReportingIcon = (props) => <CustomSVG svg={ReportingSvg} preserveColors {...props} />;
